import type * as z from 'zod/mini'
import type {LegalForm} from '../../constants/legalFormTypes'
import {isBornNumberValid} from './validations'

export const bornNumberMatchesBirthday = ({
  legalForm,
  birthday,
  bornNumber,
}: {
  legalForm: LegalForm
  birthday?: string
  bornNumber?: string
}) => isBornNumberValid(legalForm, birthday, bornNumber)

const shouldValidateBornNumber = (payload: z.core.ParsePayload) =>
  payload.issues.every((iss) => {
    const firstPathEl = iss.path?.[0]
    return firstPathEl !== 'bornNumber' && firstPathEl !== 'birthday'
  })

export const bornNumberRefinement = {
  error: 'Rodné číslo sa nezhoduje s dátumom narodenia.',
  path: ['bornNumber'],
  when: shouldValidateBornNumber,
}

export const holderBornNumberMatchesBirthday = ({
  holderLegalForm,
  holderBirthday,
  holderBornNumber,
}: {
  holderLegalForm: LegalForm
  holderBirthday?: string
  holderBornNumber?: string
}) => isBornNumberValid(holderLegalForm, holderBirthday, holderBornNumber)

const shouldValidateHolderBornNumber = (payload: z.core.ParsePayload) =>
  payload.issues.every((iss) => {
    const firstPathEl = iss.path?.[0]
    return firstPathEl !== 'holderBornNumber' && firstPathEl !== 'holderBirthday'
  })

export const holderBornNumberRefinement = {
  error: 'Rodné číslo sa nezhoduje s dátumom narodenia.',
  path: ['holderBornNumber'],
  when: shouldValidateHolderBornNumber,
}

export const ownerBornNumberMatchesBirthday = ({
  ownerLegalForm,
  ownerBirthday,
  ownerBornNumber,
}: {
  ownerLegalForm: LegalForm
  ownerBirthday?: string
  ownerBornNumber?: string
}) => isBornNumberValid(ownerLegalForm, ownerBirthday, ownerBornNumber)

const shouldValidateOwnerBornNumber = (payload: z.core.ParsePayload) =>
  payload.issues.every((iss) => {
    const firstPathEl = iss.path?.[0]
    return firstPathEl !== 'ownerBornNumber' && firstPathEl !== 'ownerBirthday'
  })

export const ownerBornNumberRefinement = {
  error: 'Rodné číslo sa nezhoduje s dátumom narodenia.',
  path: ['ownerBornNumber'],
  when: shouldValidateOwnerBornNumber,
}
